<template>
    <div class="link-layout" :class="[`link-layout-${direction}`,{'link-layout-start-exist':!!$slots.start,'link-layout-end-exist':!!$slots.end}]">
        <div class="link-layout-start">
			<div v-show="show.start" class="link-layout-wrapper">
				<slot name="start"></slot>
				<div class="divider" :style="dividerStyle"></div>
			</div>
			<div class="link-layout-collapse start" @click.stop="openStart" v-show="!show.start">
				<link-icon icon="icon-liebiao"/>
			</div>
        </div>
        <div class="link-layout-center">
            <div class="link-layout-center-content">
                <slot></slot>
            </div>
        </div>
        <div class="link-layout-end">
            <div v-show="show.end" class="link-layout-wrapper">
				<div class="divider" :style="dividerStyle"></div>
                <slot name="end"></slot>
            </div>
            <div class="link-layout-collapse end" @click.stop="openEnd" v-show="!show.end">
                <link-icon icon="icon-liebiao"/>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "link-layout",
        props: {
            direction: {type: String, default: "horizontal"},
          	dividerStyle: {
              type: Object
			}
        },
        data() {
            return {
                show: {
                    start: true,
                    end: true,
                },
            }
        },
        methods: {
            closeEnd() {
                this.show.end = false
                this.$emit('endChange', false)
            },
            openEnd() {
                this.show.end = true
                this.$emit('endChange', true)
            },
            toggleEnd() {
                this[this.show.end ? 'closeEnd' : 'openEnd']()
            },
          closeStart() {
            this.show.start = false
            this.$emit('startChange', false)
          },
          openStart() {
            this.show.start = true
            this.$emit('startChange', true)
          },
          toggleStart() {
            this[this.show.start ? 'closeStart' : 'openStart']()
          },
        },
    }
</script>

<style lang="scss">
    $layout-box-shadow: 0 0 20px 10px #f1f4fb;
	$theme-bg-color: #f0f2f7;
    .link-layout {
        height: 100%;
        width: 100%;
        display: flex;

		.link-layout-wrapper{
			display: flex;
		}
		.link-layout-collapse {
			cursor: pointer;
			position: absolute;
			top: calc(50% - 16px);
			background-color: white;
			box-shadow: 0 2px 8px rgba(81, 90, 110, 0.1);
			height: 32px;
			width: 32px;
			border-radius: 32px;
			text-align: center;
			line-height: 32px;
			font-size: 12px;
			user-select: none;
			color: black !important;

			&.start{
				left: 0;
			}
			&.end{
				right: 0;
			}
		}
		.divider{
			width: 16px;
			background: $theme-bg-color;
		}
        &.link-layout-horizontal {
            flex-direction: row;

            .link-layout-start, .link-layout-end {
                width: fit-content;
                flex-shrink: 0;
                position: relative;
                z-index: 1;

                & > div:first-child {
                    height: 100%;
                }
            }

            .link-layout-end {
                .link-layout-wrapper {
                    & > div {
                        height: 100%;
                    }
                }
            }

            /*&.link-layout-start-exist {
                .link-layout-center {
                    &:before {
                        content: '';
                        position: absolute;
                        top: 0;
                        bottom: 0;
                        left: 0;
                        width: 1px;
                        box-shadow: $layout-box-shadow;
                    }
                }
            }*/

            /*&.link-layout-end-exist {
                .link-layout-center {
                    &:after {
                        content: '';
                        position: absolute;
                        top: 0;
                        bottom: 0;
                        right: 0;
                        width: 1px;
                        box-shadow: $layout-box-shadow;
                    }
                }
            }*/
        }

        &.link-layout-vertical {
            flex-direction: column;

            .link-layout-start, .link-layout-end {
                height: fit-content;
                flex-shrink: 0;

                & > div:first-child {
                    width: 100%;
                }
            }

            &.link-layout-start-exist {
                .link-layout-center {
                    &:before {
                        content: '';
                        position: absolute;
                        left: 0;
                        right: 0;
                        top: 0;
                        height: 1px;
                        box-shadow: $layout-box-shadow;
                    }
                }
            }

            &.link-layout-end-exist {
                .link-layout-center {
                    &:after {
                        content: '';
                        position: absolute;
                        left: 0;
                        right: 0;
                        bottom: 0;
                        height: 1px;
                        box-shadow: $layout-box-shadow;
                    }
                }
            }
        }

        .link-layout-center {
            flex: 1;
            overflow: hidden;
            box-sizing: border-box;
            position: relative;

            .link-layout-center-content {
                height: 100%;
                width: 100%;
                box-sizing: border-box;

                & > div:first-child {
                    width: 100%;
                    height: 100%;
                }
            }
        }
    }

    .link-layout-page {
        padding: 0 !important;
    }
</style>
